import DefaultProfile from '../../assets/default_profile.png';

// Resolves the coach's (provider's) display name, avatar and id for the
// customer-facing "You enquired about" header. The provider and their
// profileImage may not be included on the transaction yet (still loading,
// or an older include set), so every step falls back safely rather than
// throwing or rendering "undefined".
export const getProviderDisplayInfo = currentTransaction => {
  const provider = currentTransaction && currentTransaction.provider;
  const profile = provider && provider.attributes && provider.attributes.profile;
  const name = (profile && profile.displayName) || 'the coach';

  const variants =
    provider &&
    provider.profileImage &&
    provider.profileImage.attributes &&
    provider.profileImage.attributes.variants;
  const imageUrl = (variants && variants['square-small'] && variants['square-small'].url) || DefaultProfile;

  const id = provider && provider.id && provider.id.uuid;

  return { name, imageUrl, id };
};
